import { Route, Routes } from 'react-router-dom';

import { useFeatureFlag } from 'utils/featureFlagging/useFeatureFlag';

import { SettingsReviewsView } from './settingsReviews.view';
import { SettingsReviewsCreateView } from './views/create';
import { SettingsReviewsEditView } from './views/edit';

export const SettingsReviewsRoutes = (): JSX.Element | null => {
  const flags = useFeatureFlag(['trustpilot-channel']);

  if (!flags.trustpilotChannel) {
    return null;
  }

  return (
    <Routes>
      <Route path="*">
        <Route index element={<SettingsReviewsView />} />
        <Route path="create" element={<SettingsReviewsCreateView />} />
        <Route path=":id" element={<SettingsReviewsEditView />} />
      </Route>
    </Routes>
  );
};
